import { render, staticRenderFns } from "./Ecpay.vue?vue&type=template&id=39a90b09&scoped=true&"
import script from "./Ecpay.vue?vue&type=script&lang=js&"
export * from "./Ecpay.vue?vue&type=script&lang=js&"
import style0 from "./Ecpay.vue?vue&type=style&index=0&id=39a90b09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a90b09",
  null
  
)

export default component.exports